module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "container",
    attrs: {
      "id": "post"
    }
  }, [(_vm.post) ? _vm._h('div', [_vm._h('h2', {
    staticClass: "titulo"
  }, [_vm._s(_vm.post.titulo)]), " ", _vm._h('div', {
    staticClass: "contenido html ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.post.descripcion)
    }
  }), " ", (_vm.post.fuentes) ? _vm._h('div', {
    staticClass: "fuentes"
  }, [_vm._h('span', ["FUENTE: "]), " ", _vm._l((_vm.post.fuentes), function(fuente) {
    return _vm._h('span', [_vm._h('a', {
      attrs: {
        "href": fuente.link,
        "target": "_blank"
      }
    }, [_vm._s(fuente.titulo)])])
  })]) : _vm._e(), " ", _vm._h('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.volver
    }
  }, ["Volver"])]) : _vm._e(), " ", _vm._h('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdfebbba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post-Item.vue
// module id = 68
// module chunks = 1